'use strict';

import {isDeviceiOS} from './iOS';

/**
 * Sets the maximum-scale to 1.0 in the viewport meta tag.
 * Used to prevent auto zoom-in on iOS
 */
const addMaximumScaleToMetaViewport = () => {
    const el = document.querySelector('meta[name=viewport]');

    if (el !== null) {
        let content = el.getAttribute('content');
        const re = /maximum\-scale=[0-9\.]+/g;

        if (re.test(content)) {
            content = content.replace(re, 'maximum-scale=1.0');
        } else {
            content = [content, 'maximum-scale=1.0'].join(', ');
        }

        el.setAttribute('content', content);
    }
};

// The fix for auto zoom-in on iOS requires us to set the maximum-scale to 1.0 in the viewport meta tag.
// This is bad for user accessibility, because it prevents zooming altogether.
// Therefore, the fix shouldn't be loaded for sites that must be ADA compliant. Please see BSDDEV-6362.
export const init = () => {
    if (isDeviceiOS() && $('body').hasClass('compliancyFocus')) {
        addMaximumScaleToMetaViewport();
    }
};
